import React from 'react';

// disable eslint because it gets upset about the long tag below
/* eslint-disable */

/**
 * @typedef {object} RemoveAllIconProps
 * @property {string} [className]
 * @property {(event: React.MouseEvent<SVGSVGElement>) => void} [removeAllHandler]
 */

/**
 * @param {RemoveAllIconProps} props
 */
const RemoveAllIcon = (props) => {
  const { className, removeAllHandler } = props;

  return <svg data-testid='remove-all-icon' className={className} onClick={removeAllHandler} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.4059 16.6337C20.198 17.4257 20.198 18.6139 19.4059 19.4059C19.0099 19.802 18.5149 20 18.0198 20C17.5248 20 17.0297 19.802 16.6337 19.4059L10 12.7723L3.36634 19.4059C2.9703 19.802 2.47525 20 1.9802 20C1.48515 20 0.990099 19.802 0.594059 19.4059C-0.19802 18.6139 -0.19802 17.4257 0.594059 16.6337L7.22772 10L0.594059 3.36634C-0.19802 2.57426 -0.19802 1.38614 0.594059 0.594059C1.38614 -0.19802 2.57426 -0.19802 3.36634 0.594059L10 7.22772L16.6337 0.594059C17.4257 -0.19802 18.6139 -0.19802 19.4059 0.594059C20.198 1.38614 20.198 2.57426 19.4059 3.36634L12.7723 10L19.4059 16.6337Z" fill="#9E9E9E" />
  </svg>
}
/* eslint-enable */

export default RemoveAllIcon;
